<template>
  <v-row align="center" justify="center">
    <v-col cols="12">
      <v-card shaped>
        <v-card-title>
          <v-icon large left color="primary">mdi-monitor-eye</v-icon>
          <span class="title font-weight-light">Переходы по экранам</span>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="loading.download"
            :disabled="loading.report"
            @click="DownloadReport"
          >
            <v-icon left>mdi-microsoft-excel</v-icon>Скачать Excel
          </v-btn>
        </v-card-title>
        <v-col>
          <v-expansion-panels flat>
            <v-expansion-panel>
              <v-expansion-panel-header>Немного об отчёте</v-expansion-panel-header>
              <v-expansion-panel-content>
                <p class="text-justify mb-1">
                  Сколько раз пользователи открывали экраны платформы: строка — логин, экран и месяц. Переход
                  считается при каждом открытии экрана (в том числе после обновления страницы); переключение
                  вкладок внутри «Потребности» переходом не считается.
                </p>
                <p class="text-justify mb-0">
                  Данные копятся с момента запуска трекинга, за более ранние периоды отчёт пустой. Период по умолчанию —
                  текущий месяц, экраны по умолчанию — Главная, Потребность, Планировщик, Фарм-чат. Учитываются все роли.
                </p>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <v-form ref="form" @submit.prevent="LoadReport">
          <v-row class="px-4">
            <v-col cols="12" sm="6" md="2">
              <v-text-field v-model="search.dateStart" type="date" label="Дата с" persistent-hint hint="Пусто — 1-е число месяца"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-text-field v-model="search.dateEnd" type="date" label="Дата по" persistent-hint hint="Пусто — сегодня"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-select
                v-model="search.pageNames"
                :items="options.pages"
                item-text="title"
                item-value="name"
                label="Экраны"
                multiple
                chips
                small-chips
                deletable-chips
                :loading="loading.options"
                persistent-hint
                hint="Пусто — четыре экрана по умолчанию"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-select
                v-model="search.roleIds"
                :items="options.roles"
                item-text="name"
                item-value="id"
                label="Роли"
                multiple
                chips
                small-chips
                deletable-chips
                :loading="loading.options"
                persistent-hint
                hint="Пусто — все"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-text-field v-model="search.search" label="Логин или компания" prepend-icon="mdi-magnify" clearable></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="1" class="d-flex align-center">
              <v-btn color="primary" type="submit" :loading="loading.report" block>Показать</v-btn>
            </v-col>
          </v-row>
        </v-form>

        <v-row class="px-4 pb-2" v-if="report.totals.length">
          <v-col cols="auto" v-for="total in report.totals" :key="total.pageName">
            <v-chip color="primary" outlined>
              {{ total.pageTitle || total.pageName }} — {{ total.views }} переходов, {{ total.uniqueUsers }} логинов
            </v-chip>
          </v-col>
        </v-row>
        <v-row class="px-4" v-if="report.dateStart">
          <v-col class="caption grey--text pt-0">
            Период: {{ FormatDate(report.dateStart) }} — {{ FormatDate(report.dateEnd) }}
          </v-col>
        </v-row>

        <v-data-table
          :headers="headers"
          :items="report.rows"
          :loading="loading.report"
          :items-per-page="50"
          :footer-props="{ 'items-per-page-options': [50, 100, 500, -1] }"
          class="elevation-1"
        >
          <template v-slot:item.pageTitle="{ item }">
            {{ item.pageTitle || item.pageName }}
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    search: {
      dateStart: "",
      dateEnd: "",
      pageNames: [],
      roleIds: [],
      search: "",
    },
    options: { pages: [], roles: [], defaultPageNames: [] },
    report: { rows: [], totals: [], dateStart: null, dateEnd: null },
    loading: { options: true, report: false, download: false },
    headers: [
      { text: "Логин", value: "login" },
      { text: "Компания", value: "company" },
      { text: "Роль", value: "role" },
      { text: "Экран", value: "pageTitle" },
      { text: "Месяц", value: "month" },
      { text: "Переходов", value: "views", align: "end" },
    ],
  }),
  async mounted() {
    await this.GetFilterOptions();
    this.LoadReport();
  },
  methods: {
    async GetFilterOptions() {
      this.loading.options = true;
      try {
        this.options = await this.$store.dispatch("PAGE_VIEW_REPORT_FILTER_OPTIONS");
        // по умолчанию показываем четыре экрана заказчика, в селекте они видны явно
        if (!this.search.pageNames.length) this.search.pageNames = [...(this.options.defaultPageNames || [])];
      } catch (error) {
        window.console.log(error);
      } finally {
        this.loading.options = false;
      }
    },
    Request() {
      return {
        dateStart: this.search.dateStart || null,
        dateEnd: this.search.dateEnd || null,
        pageNames: this.search.pageNames,
        roleIds: this.search.roleIds,
        search: this.search.search || null,
      };
    },
    async LoadReport() {
      this.loading.report = true;
      try {
        this.report = await this.$store.dispatch("PAGE_VIEW_REPORT", this.Request());
      } catch (error) {
        window.console.log(error);
      } finally {
        this.loading.report = false;
      }
    },
    DownloadReport() {
      this.loading.download = true;
      this.$store
        .dispatch("DOWNLOAD_PAGE_VIEW_REPORT", this.Request())
        .catch((error) => window.console.log(error))
        .finally(() => {
          this.loading.download = false;
        });
    },
    FormatDate(value) {
      return value ? this.$options.filters.toDate(String(value).substr(0, 10)) : "";
    },
  },
};
</script>
